export default [
    {
        path: '/',
        meta: {},
        component: () => import('@/views/37/index')
    },
]
